import React from 'react';
import profileStyles from './UserProfile.module.scss';
import MoreValuesPopover from '../../../../../../../common/AllKnownDetails/components/MoreValuesPopover/MoreValuesPopover';
import SourceAttribution from '../../../../../../../common/AllKnownDetails/components/SourceAttribution/SourceAttribution';
import { EMPTY_VALUE_PLACEHOLDER } from '../../../../../../../common/AllKnownDetails/constants';
import {
    attributeValues,
    displayValueFor,
    indexOfDisplayedValue,
} from '../../../../../../../common/AllKnownDetails/utils/allKnownDetailsUtils';
import type { ContactRowProps } from './ManagementUserProfile.types';

/** One contact line in the left rail. The row always renders: with no value anywhere it shows the
 *  placeholder, and it names the source only when a source actually reported the value on show. */
const ContactRow = ({ icon, type, value, groups }: ContactRowProps) => {
    const attributed = attributeValues(groups, 'MANAGEMENT_PROFILE');
    const shown = attributed[indexOfDisplayedValue(attributed, value, type)];

    return (
        <div className={profileStyles.ContactRow}>
            <img src={icon} alt={''} height={'18px'} />
            <span>
                {value ? displayValueFor(value, type) : EMPTY_VALUE_PLACEHOLDER}
                <SourceAttribution source={shown?.source} />
                <MoreValuesPopover groups={groups} type={type} entityType="MANAGEMENT_PROFILE" displayedValue={value ?? ''} />
            </span>
        </div>
    );
};

export default ContactRow;
